export const environment = {
  local:null,GOOGLE_API_KEY:"AIzaSyAiiJgKHjR7sxhmAaeMoRsvhsO0Ttk5R0M",Holidays:{RecurringHolidays:null,OtherHolidays:null,Weekends:"Sunday"},ApiTimeout:100,production:true
}